import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import { UrlObject } from "url";
import { useCurrentProjectId } from "lib/hooks/useProject";
import { useProjectView } from "lib/hooks/useProjectView";

export default function BreadcrumbView(p: {
  params: string[];
  href: UrlObject;
}) {
  const viewId = p.params[0] && +p.params[0];
  const projectId = useCurrentProjectId();
  const { view } = useProjectView(projectId, viewId);

  return <BreadcrumbLink href={p.href}>{view?.name || "View"}</BreadcrumbLink>;
}
